import { Injectable } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { DateRange, MatDateRangeSelectionStrategy } from '@angular/material/datepicker';
import { DateFormatStyle } from '@grupo-constant/next-dtype/types';

export class DateFormat {

    style: DateFormatStyle;

    constructor() { }

    get display() {
        switch (this.style) {
            case DateFormatStyle.SHORT:
                return {
                    dateInput: 'DD/MM/yyyy',
                    monthYearLabel: 'MMM yyyy',
                    dateA11yLabel: 'LL',
                    monthYearA11yLabel: 'MMMM yyyy',
                };
            case DateFormatStyle.MEDIUM:
                return {
                    dateInput: 'DD MMM yyyy',
                    monthYearLabel: 'MMM yyyy',
                    dateA11yLabel: 'LL',
                    monthYearA11yLabel: 'MMMM yyyy',
                };
            case DateFormatStyle.LONG:
                return {
                    dateInput: 'LL',
                    monthYearLabel: 'MMM yyyy',
                    dateA11yLabel: 'LL',
                    monthYearA11yLabel: 'MMMM yyyy',
                };
            case DateFormatStyle.FULL:
                return {
                    dateInput: 'dddd, DD MMMM yyyy',
                    monthYearLabel: 'MMM yyyy',
                    dateA11yLabel: 'LL',
                    monthYearA11yLabel: 'MMMM yyyy',
                };
            default:
                return {
                    dateInput: 'DD/MM/yyyy',
                    monthYearLabel: 'MMM yyyy',
                    dateA11yLabel: 'LL',
                    monthYearA11yLabel: 'MMMM yyyy',
                };
        }
    }

    get parse() {
        return {
            dateInput: 'yyyy-MM-dd'
        };
    }

}

@Injectable()
export class CustomRangeSelectionStrategy<D> implements MatDateRangeSelectionStrategy<D> {

    days = 0;

    constructor(private _dateAdapter: DateAdapter<D>) { }

    selectionFinished(date: D | null, currentRange: DateRange<D>): DateRange<D> {
        if (this.days === 0) {
            let { start, end } = currentRange;
            if (start == null) {
                start = date;
            } else if (end == null && date && this._dateAdapter.compareDate(date, start) >= 0) {
                end = date;
            } else {
                start = date;
                end = null;
            }
            return new DateRange(start, end);
        }
        return this._createRange(date, currentRange);
    }

    createPreview(activeDate: D | null, currentRange: DateRange<D>): DateRange<D> {
        if (this.days === 0) {
            let start = null;
            let end = null;
            if (currentRange.start && !currentRange.end && activeDate) {
                start = currentRange.start;
                end = activeDate;
            }
            return new DateRange(start, end);
        }
        return this._createRange(activeDate, currentRange);
    }

    private _createRange(date: D | null, currentRange: DateRange<D>): DateRange<D> {
        if (date && this.days) {
            let minus: number; let plus: number;
            if (this.days % 2 === 1) {
                minus = Math.floor(this.days / 2);
                plus = Math.floor(this.days / 2);
            } else {
                minus = Math.floor(this.days / 2) - 1;
                plus = Math.floor(this.days / 2);
            }
            const start = this._dateAdapter.addCalendarDays(date, -minus);
            const end = this._dateAdapter.addCalendarDays(date, plus);
            return new DateRange<D>(start, end);
        }

        return new DateRange<D>(null, null);
    }

}
